import React from 'react';
import IconVideriLogo from './Icons';
import '../../assets/css/LogoTriage.css';

/* ===========================
RENDER
=========================== */
function LogoTriage() {
  return (
    <div className="logo triage">
      <IconVideriLogo />
      <span>Triage</span>
    </div>
  );
}

/* ===========================
EXPORT
=========================== */
export default LogoTriage;
